import { render, staticRenderFns } from "./LinearScaleBuilder.vue?vue&type=template&id=2f390466&"
import script from "./LinearScaleBuilder.vue?vue&type=script&lang=ts&"
export * from "./LinearScaleBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./LinearScaleBuilder.vue?vue&type=style&index=0&id=2f390466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports